<template>
  <header
    class="header"
    :class="{ home: isHome, scrolled: isScrolled, hovered: isHovered }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <!-- 顶部通知栏 -->
    <div class="notification-bar" v-if="notifications.length > 0">
      <button class="notification-arrow notification-prev" @click="prevNotification">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <div class="notification-content">
        <span>{{ notifications[currentNotificationIndex] }}</span>
      </div>
      <button class="notification-arrow notification-next" @click="nextNotification">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>

    <!-- 主头部：语言切换 | logo+导航 | 操作图标 -->
    <div class="nav_main_head">
      <div class="wrapper">
        <!-- 左侧：语言切换 -->
        <div class="header-left">
          <div class="lang-toggle" @click="toggleLanguage">
            {{ $t('header.switch_to') }}
          </div>
        </div>

        <!-- 中间：logo + 导航 -->
        <div class="header-center">
          <div class="logo" @click="$router.push('/')">
            <img class="logo-img" :src="logoImg" alt="CIGARERA" />
          </div>
          <nav class="header-nav">
            <div class="nav-item">
              <div class="nav-link" :class="{ active: $route.path === '/' }" @click="$router.push('/')">
                {{ $t('header.home') }}
              </div>
            </div>
            <div
              class="nav-item"
              :class="{ 'has-dropdown': cat.id === cubaCategoryId }"
              v-for="cat in categories"
              :key="cat.id"
              @mouseenter="cat.id === cubaCategoryId && openDropdown('cuba')"
              @mouseleave="cat.id === cubaCategoryId && closeDropdown('cuba')"
            >
              <div class="nav-link" :class="{ active: $route.query.cat == cat.id }" @click="goCuba('/products?cat=' + cat.id)">
                {{ $store.state.language === 'en' ? (cat.nameEn || cat.name) : cat.name }}
              </div>
              <!-- 古巴雪茄下拉 -->
              <div
                v-if="cat.id === cubaCategoryId"
                class="submenu-container cuba-submenu"
                :class="{ active: activeDropdown === 'cuba' }"
                @mouseenter="openDropdown('cuba')"
                @mouseleave="closeDropdown('cuba')"
              >
                <div class="submenu-inner">
                  <!-- 左侧品牌快捷列表 -->
                  <div class="cuba-submenu-sidebar">
                    <div class="sidebar-all" @click="goCuba('/products?cat=' + cat.id)">{{ $t('header.query_all_brands') }}</div>
                    <div class="sidebar-list">
                      <div
                        v-for="brand in cubaBrands.slice(0, 10)"
                        :key="'side-' + brand.id"
                        class="sidebar-item"
                        @click="goCuba(brand.link)"
                      >
                        {{ $store.state.language === 'en' ? (brand.nameEn || brand.name) : brand.name }}
                      </div>
                    </div>
                  </div>
                  <div class="submenu-divider"></div>
                  <!-- 右侧内容 -->
                  <div class="cuba-submenu-main">
                    <button class="btn-showall" @click="goCuba('/products?cat=' + cat.id)">{{ $t('header.view_all_brands') }}</button>
                    <div class="brand-grid">
                      <div
                        v-for="brand in cubaBrands"
                        :key="brand.id"
                        class="brand-box"
                        @click="goCuba(brand.link)"
                      >
                        <div class="brand-image">
                          <img :src="brand.image" :alt="brand.name" />
                        </div>
                        <div class="brand-name">
                          <div class="name-tc">{{ $store.state.language === 'en' ? (brand.nameEn || brand.name) : brand.name }}</div>
                          <div class="name-en">{{ brand.nameEn || brand.name }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="nav-item">
              <div class="nav-link" :class="{ active: $route.path === '/news' || $route.path === '/newsdetail' }" @click="$router.push('/news')">
                {{ $t('header.cigar_news') }}
              </div>
            </div>
            <div class="nav-item">
              <div class="nav-link" :class="{ active: $route.path === '/contact' }" @click="$router.push('/contact')">
                {{ $t('header.contact_us') }}
              </div>
            </div>
          </nav>
        </div>

        <!-- 右侧：操作图标 -->
        <div class="header-actions btn_main_bigthree">
          <div class="action-icon search-icon" @click="toggleSearch">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </div>
          <div
            class="account-dropdown-wrap"
            :class="{ open: showAccountDropdown }"
            @click.stop
          >
            <div class="action-icon account-icon" @click.stop="goAccount">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <div v-if="isLoggedIn && showAccountDropdown" class="account-dropdown">
              <div
                v-for="item in accountMenuItems"
                :key="item.id"
                class="account-dropdown-item"
                @click="handleAccountMenu(item)"
              >
                <span class="account-dropdown-icon" v-html="item.icon"></span>
                <span class="account-dropdown-label">{{ $t(`header.account_menu.${item.id}`) }}</span>
              </div>
            </div>
          </div>
          <div class="action-icon cart-icon" @click="openCartModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
            <span v-if="cartCount > 0" class="cart-badge">{{ cartCount }}</span>
          </div>
          <div class="hamburger-icon" @click="toggleMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索栏（fixed全屏覆盖） -->
    <div class="topsearch" :class="{ active: showSearch }">
      <div class="searchbar">
        <input
          v-model="searchKeyword"
          type="text"
          :placeholder="$t('common.search_placeholder')"
          @keyup.enter="handleSearch"
        />
        <button class="search-btn" @click="handleSearch">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        </button>
        <button class="search-close" @click="toggleSearch">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
    </div>

    <!-- 底部菜单栏 -->
    <div class="nav_main_menu">
      <div class="wrapper">
        <!-- 左侧：首页 -->
        <div class="menu_list_l">
          <div class="menu-item">
            <div class="menu-link effect-underline" :class="{ active: $route.path === '/' }" @click="$router.push('/')">
              {{ $t('header.home') }}
            </div>
          </div>
        </div>

        <!-- 中间分类按钮 -->
        <div class="menu-center">
          <div
            class="menu-item"
            :class="{ 'has-dropdown': cat.id === cubaCategoryId }"
            v-for="cat in categories"
            :key="cat.id"
            @mouseenter="cat.id === cubaCategoryId && openDropdown('cuba')"
            @mouseleave="cat.id === cubaCategoryId && closeDropdown('cuba')"
          >
            <div class="menu-link effect-underline" :class="{ active: $route.query.cat == cat.id }" @click="goCuba('/products?cat=' + cat.id)">
              {{ $store.state.language === 'en' ? (cat.nameEn || cat.name) : cat.name }}
            </div>
            <!-- 古巴雪茄下拉 -->
            <div
              v-if="cat.id === cubaCategoryId"
              class="submenu-container cuba-submenu"
              :class="{ active: activeDropdown === 'cuba' }"
              @mouseenter="openDropdown('cuba')"
              @mouseleave="closeDropdown('cuba')"
            >
              <div class="submenu-inner">
                <!-- 左侧品牌快捷列表 -->
                <div class="cuba-submenu-sidebar">
                  <div class="sidebar-all" @click="goCuba('/products?cat=' + cat.id)">{{ $t('header.query_all_brands') }}</div>
                  <div class="sidebar-list">
                    <div
                      v-for="brand in cubaBrands.slice(0, 10)"
                      :key="'side-' + brand.id"
                      class="sidebar-item"
                      @click="goCuba(brand.link)"
                    >
                      {{ $store.state.language === 'en' ? (brand.nameEn || brand.name) : brand.name }}
                    </div>
                  </div>
                </div>
                <div class="submenu-divider"></div>
                <!-- 右侧内容 -->
                <div class="cuba-submenu-main">
                  <button class="btn-showall" @click="goCuba('/products?cat=' + cat.id)">{{ $t('header.view_all_brands') }}</button>
                  <div class="brand-grid">
                    <div
                      v-for="brand in cubaBrands"
                      :key="brand.id"
                      class="brand-box"
                      @click="goCuba(brand.link)"
                    >
                      <div class="brand-image">
                        <img :src="brand.image" :alt="brand.name" />
                      </div>
                      <div class="brand-name">
                        <div class="name-tc">{{ $store.state.language === 'en' ? (brand.nameEn || brand.name) : brand.name }}</div>
                        <div class="name-en">{{ brand.nameEn || brand.name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="menu_list_r">
          <div class="menu-item">
            <div class="menu-link effect-underline" :class="{ active: $route.path === '/news' || $route.path === '/newsdetail' }" @click="$router.push('/news')">
              {{ $t('header.cigar_news') }}
            </div>
          </div>
          <div class="menu-item">
            <div class="menu-link effect-underline" :class="{ active: $route.path === '/contact' }" @click="$router.push('/contact')">
              {{ $t('header.contact_us') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div class="mobile-menu" :class="{ active: showMobileMenu }">
      <div class="mobile-menu-header">
        <div class="close-btn" @click="toggleMobileMenu">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </div>
      </div>
      <div class="mobile-menu-body">
        <div class="mobile-menu-item">
          <div class="mobile-menu-link" @click="$router.push('/'); toggleMobileMenu()">
            {{ $t('header.mobile_menu.home') }}
          </div>
        </div>
        <div class="mobile-menu-item" v-for="cat in categories" :key="'m-' + cat.id">
          <div
            class="mobile-menu-link"
            :class="{ 'has-children': cat.id === cubaCategoryId }"
            @click="cat.id === cubaCategoryId ? toggleMobileSubmenu('cuba') : goCategory(cat.id)"
          >
            {{ $store.state.language === 'en' ? (cat.nameEn || cat.name) : cat.name }}
            <svg
              v-if="cat.id === cubaCategoryId"
              class="chevron-icon"
              :class="{ rotated: openMobileSubmenu === 'cuba' }"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </div>
          <!-- 古巴雪茄 H5 下拉品牌 -->
          <div
            v-if="cat.id === cubaCategoryId"
            class="mobile-submenu mobile-cuba-submenu"
            :class="{ active: openMobileSubmenu === 'cuba' }"
          >
            <div class="mobile-submenu-link mobile-submenu-all" @click="goCategory(cat.id)">
              {{ $t('header.view_all_brands') }}
            </div>
            <div
              v-for="brand in cubaBrands"
              :key="'m-brand-' + brand.id"
              class="mobile-submenu-link mobile-cuba-brand"
              @click="$router.push(brand.link); toggleMobileMenu()"
            >
              <img class="mobile-brand-logo" :src="brand.image" :alt="brand.name" />
              <span>{{ $store.state.language === 'en' ? (brand.nameEn || brand.name) : brand.name }}</span>
            </div>
          </div>
        </div>
        <div class="mobile-menu-item">
          <div class="mobile-menu-link" @click="$router.push('/news'); toggleMobileMenu()">
            {{ $t('header.mobile_menu.cigar_news') }}
          </div>
        </div>
        <div class="mobile-menu-item">
          <div class="mobile-menu-link" @click="$router.push('/contact'); toggleMobileMenu()">
            {{ $t('header.mobile_menu.contact_us') }}
          </div>
        </div>
        <div class="mobile-lang-toggle">
          <div class="mobile-lang-btn" @click="toggleLanguage">{{ currentLangLabel }}</div>
        </div>
      </div>
    </div>
    <div class="mobile-overlay" :class="{ active: showMobileMenu }" @click="toggleMobileMenu"></div>

    <!-- 通知抽屉 -->
    <div
      class="notification-overlay"
      :class="{ active: showNotificationDrawer }"
      @click="closeNotificationDrawer"
    ></div>
    <div class="notification-drawer" :class="{ active: showNotificationDrawer }">
      <button class="notification-close" @click="closeNotificationDrawer" :aria-label="$t('common.close')">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <div class="notification-drawer-inner">
        <div class="notification-drawer-header">
          <h2 class="notification-drawer-title">{{ $t('notifications.title') }}</h2>
          <div class="notification-filter" @click.stop>
            <button
              class="notification-filter-trigger"
              :class="{ open: showNotificationFilter }"
              @click="toggleNotificationFilter"
            >
              {{ activeNotificationFilterLabel }}
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
            </button>
            <ul v-show="showNotificationFilter" class="notification-filter-menu">
              <li
                v-for="option in notificationFilterOptions"
                :key="option.value"
                class="notification-filter-item"
                :class="{ active: notificationFilter === option.value }"
                @click="selectNotificationFilter(option.value)"
              >
                {{ $t(option.label) }}
              </li>
            </ul>
          </div>
        </div>
        <div class="notification-drawer-body">
          <p v-if="notificationsLoading" class="notification-loading">{{ $t('notifications.loading') }}</p>
          <p v-else-if="filteredNotifications.length === 0" class="notification-empty">{{ $t('notifications.empty') }}</p>
          <div
            v-else
            v-for="item in filteredNotifications"
            :key="item.id"
            class="notification-item"
            :class="{ unread: !item.read }"
            @click="markNotificationRead(item.id)"
          >
            <p class="notification-item-title">{{ item.title }}</p>
            <p class="notification-item-content">{{ item.content }}</p>
            <span class="notification-item-time">{{ item.time }}</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import logoImg from '@/assets/static/index/tcc_logo_timeclub.png'
import { NOTIFICATION_FILTER_OPTIONS } from '@/api/notification'
import { homeApi } from '@/api/home'
import { getFullUrl } from '@/api/request'

export default {
  name: 'AppHeader',
  data() {
    return {
      logoImg,
      searchKeyword: '',
      showSearch: false,
      showMobileMenu: false,
      showNotificationDrawer: false,
      showNotificationFilter: false,
      showAccountDropdown: false,
      isScrolled: false,
      isHovered: false,
      accountMenuItems: [
        {
          id: 'overview',
          labelKey: 'account_modal.overview',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>'
        },
        {
          id: 'profile',
          labelKey: 'account_modal.profile',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>'
        },
        {
          id: 'orders',
          labelKey: 'account_modal.orders',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>'
        },
        // {
        //   id: 'receipts',
        //   labelKey: 'account_modal.receipts',
        //   icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>'
        // },
        {
          id: 'coupons',
          labelKey: 'account_modal.coupons',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
        },
        {
          id: 'logout',
          labelKey: 'account_modal.logout',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>'
        }
      ],
      notificationFilter: 'all',
      notificationFilterOptions: NOTIFICATION_FILTER_OPTIONS,
      openMobileSubmenu: '',
      activeDropdown: '',
      dropdownTimer: null,
      notifications: [],
      currentNotificationIndex: 0,
      notificationTimer: null,
      categories: [],
      cubaBrands: [],
      featuredBrand: {
        nameCn: '唯佳',
        title: '源自完美風土的絲滑饗宴',
        desc: '來自多米尼加與尼加拉瓜的頂級煙葉，經過數年陳化與匠心卷製，呈現絲滑細膩的口感與層次豐富的香氣，是品味雪茄的經典之選。',
        image: 'https://aka.doubaocdn.com/s/JLV71wXbKo',
        link: '/products?brand=46'
      },
      worldBrands: [
        { id: 186, nameCn: '阿拉丁', nameEn: 'Aladino', image: 'https://aka.doubaocdn.com/s/Jo9H1wXbKo', link: '/products?brand=186' },
        { id: 177, nameCn: '大都會', nameEn: 'Capitol', image: 'https://aka.doubaocdn.com/s/n3bI1wXbKo', link: '/products?brand=177' },
        { id: 200, nameCn: '傳奇大陸', nameEn: 'El Viejo Continente', image: 'https://aka.doubaocdn.com/s/YWg61wXbKo', link: '/products?brand=200' },
        { id: 55, nameCn: '帕拉森', nameEn: 'Plasencia', image: 'https://aka.doubaocdn.com/s/Jo9H1wXbKo', link: '/products?brand=55' },
        { id: 9, nameCn: '大衛杜夫', nameEn: 'Davidoff', image: 'https://aka.doubaocdn.com/s/D8GG1wXbKo', link: '/products?brand=9' },
        { id: 46, nameCn: '唯佳', nameEn: 'VegaFina', image: 'https://aka.doubaocdn.com/s/JLV71wXbKo', link: '/products?brand=46' },
        { id: 27, nameCn: '多米尼加之花', nameEn: 'La Flor Dominicana', image: 'https://aka.doubaocdn.com/s/AUVU1wXbKo', link: '/products?brand=27' },
        { id: 75, nameCn: 'AJ費爾南德斯', nameEn: 'AJ Fernandez', image: 'https://aka.doubaocdn.com/s/ioHg1wXbKo', link: '/products?brand=75' },
        { id: 5, nameCn: '阿圖羅·富恩特', nameEn: 'Arturo Fuente', image: 'https://aka.doubaocdn.com/s/UHTC1wXbKo', link: '/products?brand=5' },
        { id: 70, nameCn: '奧利瓦', nameEn: 'Oliva', image: 'https://aka.doubaocdn.com/s/gjlR1wXbKo', link: '/products?brand=70' },
        { id: 15, nameCn: '科潘之花', nameEn: 'Flor de Copan', image: 'https://aka.doubaocdn.com/s/AUVU1wXbKo', link: '/products?brand=15' },
        { id: 11, nameCn: '當·迪亞哥', nameEn: 'Don Diego', image: 'https://aka.doubaocdn.com/s/UHTC1wXbKo', link: '/products?brand=11' },
        { id: 88, nameCn: '亨利·克萊', nameEn: 'Henry Clay', image: 'https://aka.doubaocdn.com/s/UHTC1wXbKo', link: '/products?brand=88' },
        { id: 42, nameCn: '歐普斯 X', nameEn: 'Opus X', image: 'https://aka.doubaocdn.com/s/gjlR1wXbKo', link: '/products?brand=42' },
        { id: 63, nameCn: '洛基·帕特爾', nameEn: 'Rocky Patel', image: 'https://aka.doubaocdn.com/s/ioHg1wXbKo', link: '/products?brand=63' },
        { id: 91, nameCn: '托雷斯尼加拉瓜', nameEn: 'Torres de Nicaragua', image: 'https://aka.doubaocdn.com/s/n3bI1wXbKo', link: '/products?brand=91' },
        { id: 33, nameCn: '阿爾凡布拉', nameEn: 'Alfambra', image: 'https://aka.doubaocdn.com/s/AUVU1wXbKo', link: '/products?brand=33' },
        { id: 18, nameCn: '羅密歐與朱麗葉', nameEn: 'Romeo y Julieta', image: 'https://aka.doubaocdn.com/s/D8GG1wXbKo', link: '/products?brand=18' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'cartCount',
      'isLoggedIn',
      'userNotifications',
      'unreadNotificationCount',
      'notificationsLoading'
    ]),
    isHome() {
      return this.$route.path === '/' || this.$route.path === '/timeclub'
    },
    filteredNotifications() {
      if (this.notificationFilter === 'all') {
        return this.userNotifications
      }
      return this.userNotifications.filter(item => item.category === this.notificationFilter)
    },
    activeNotificationFilterLabel() {
      const current = this.notificationFilterOptions.find(
        option => option.value === this.notificationFilter
      )
      return current ? this.$t(current.label) : this.$t('notifications.filter.all')
    },
    currentLangLabel() {
      return this.$store.state.language === 'zh' ? 'EN' : '繁體中文'
    },
    cubaCategoryId() {
      const cat = this.categories.find(c => {
        const name = (c.name || '').trim()
        return name === '古巴雪茄' || name === '古巴'
      })
      return cat ? cat.id : ''
    }
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick)
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.fetchNotice()
    this.startNotificationRotation()
    this.fetchCategories()
    this.fetchCubaData()
    this.handleScroll()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick)
    window.removeEventListener('scroll', this.handleScroll)
    this.stopNotificationRotation()
  },
  watch: {
    isLoggedIn(loggedIn) {
      if (loggedIn) {
        this.loadNotifications()
      } else {
        this.closeNotificationDrawer()
        this.closeAccountDropdown()
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SEARCH_KEYWORD']),
    ...mapActions([
      'openCartModal',
      'openLoginModal',
      'showToast',
      'loadNotifications',
      'markNotificationRead',
      'logout',
      'openAccountModal'
    ]),
    toggleSearch() {
      this.showSearch = !this.showSearch
    },
    async fetchNotice() {
      try {
        const res = await this.$api.home.getNotice()
        if (res.code === 1 && Array.isArray(res.data)) {
          const isEn = this.$store.state.language === 'en'
          this.notifications = res.data.map(item => isEn ? (item.info_en || item.info) : item.info)
        }
      } catch (e) {
        console.error('公告获取失败', e)
      }
    },
    async fetchCategories() {
      try {
        const res = await this.$api.home.getCategories()
        if (res.code === 1 && Array.isArray(res.data)) {
          this.categories = res.data.map(item => ({
            id: item.id,
            name: item.name || item.title || '',
            nameEn: item.name_en || ''
          }))
        }
      } catch (e) {
        console.error('商品分类获取失败', e)
      }
    },
    async fetchCubaData() {
      if (!this.cubaCategoryId) {
        // 分类数据可能还没回来，延迟再试一次
        setTimeout(() => {
          if (this.cubaCategoryId) {
            this.fetchCubaData()
          }
        }, 500)
        return
      }
      await this.fetchCubaBrands()
    },
    async fetchCubaBrands() {
      try {
        const res = await homeApi.getBrands({ cate_id: this.cubaCategoryId, page: 1, count: 200 })
        if (res.code === 1 && res.data && Array.isArray(res.data.list)) {
          this.cubaBrands = res.data.list.map(item => ({
            id: item.id,
            name: item.name || '',
            nameEn: item.name_en || '',
            image: getFullUrl(item.image),
            link: '/products?cat=' + this.cubaCategoryId + '&brand=' + item.id
          }))
        }
      } catch (e) {
        console.error('古巴雪茄品牌获取失败', e)
      }
    },
    handleSearch() {
      const keyword = (this.searchKeyword || '').trim()
      if (!keyword) return
      this.SET_SEARCH_KEYWORD(keyword)
      this.searchKeyword = keyword
      this.$router.push({ path: '/products', query: { keyword } })
      this.showSearch = false
    },
    goAccount() {
      if (this.isLoggedIn) {
        this.showAccountDropdown = !this.showAccountDropdown
        return
      }
      this.closeAccountDropdown()
      this.openLoginModal()
    },
    closeAccountDropdown() {
      this.showAccountDropdown = false
    },
    handleDocumentClick() {
      this.closeNotificationFilter()
      this.closeAccountDropdown()
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 30
    },
    handleAccountMenu(item) {
      this.closeAccountDropdown()
      if (item.id === 'logout') {
        this.logout()
        this.showToast({ message: this.$t('account_modal.logged_out'), type: 'success' })
        return
      }
      this.openAccountModal(item.id)
    },
    goPromotion(id) {
      this.$router.push({ path: '/products', query: { promo: id } })
    },
    openDropdown(name) {
      if (this.dropdownTimer) {
        clearTimeout(this.dropdownTimer)
        this.dropdownTimer = null
      }
      this.activeDropdown = name
    },
    closeDropdown(name) {
      this.dropdownTimer = setTimeout(() => {
        if (this.activeDropdown === name) {
          this.activeDropdown = ''
        }
      }, 150)
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu
      this.updateBodyScrollLock()
    },
    toggleLanguage() {
      const newLang = this.$store.state.language === 'zh' ? 'en' : 'zh'
      this.$store.commit('SET_LANGUAGE', newLang)
      window.location.reload()
    },
    toggleNotificationDrawer() {
      const willOpen = !this.showNotificationDrawer
      this.showNotificationDrawer = willOpen
      if (willOpen) {
        this.loadNotifications()
      }
      this.updateBodyScrollLock()
    },
    closeNotificationDrawer() {
      this.showNotificationDrawer = false
      this.closeNotificationFilter()
      this.updateBodyScrollLock()
    },
    toggleNotificationFilter() {
      this.showNotificationFilter = !this.showNotificationFilter
    },
    closeNotificationFilter() {
      this.showNotificationFilter = false
    },
    selectNotificationFilter(value) {
      this.notificationFilter = value
      this.closeNotificationFilter()
    },
    updateBodyScrollLock() {
      const locked = this.showMobileMenu || this.showNotificationDrawer
      if (locked) {
        document.body.style.overflow = 'hidden'
        document.body.style.position = 'fixed'
        document.body.style.width = '100%'
        document.body.style.height = '100%'
      } else {
        document.body.style.overflow = ''
        document.body.style.position = ''
        document.body.style.width = ''
        document.body.style.height = ''
      }
    },
    toggleMobileSubmenu(name) {
      this.openMobileSubmenu = this.openMobileSubmenu === name ? '' : name
    },
    goCategory(catId) {
      this.$router.push('/products?cat=' + catId)
      this.toggleMobileMenu()
    },
    goCuba(path) {
      this.activeDropdown = ''
      this.$router.push(path)
    },
    startNotificationRotation() {
      this.notificationTimer = setInterval(() => {
        this.nextNotification()
      }, 5000)
    },
    stopNotificationRotation() {
      if (this.notificationTimer) {
        clearInterval(this.notificationTimer)
        this.notificationTimer = null
      }
    },
    nextNotification() {
      this.currentNotificationIndex = (this.currentNotificationIndex + 1) % this.notifications.length
    },
    prevNotification() {
      this.currentNotificationIndex = (this.currentNotificationIndex - 1 + this.notifications.length) % this.notifications.length
    }
  }
}
</script>

<style lang="scss" scoped>
/* ============================================
   Header 主容器
   ============================================ */
.header {
  position: sticky;
  top: -1px;
  z-index: 100;
  background: #fff;
  transition: background 0.3s ease, box-shadow 0.3s ease;

  &.home {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: transparent;
    color: #fff;

    .nav_main_head,
    .nav_main_menu {
      background: transparent;
    }

    .nav-link,
    .lang-toggle,
    .action-icon,
    .hamburger-icon span {
      color: #fff;
    }

    .hamburger-icon span {
      background: #fff;
    }

    .logo-img {
      filter: brightness(0) invert(1);
    }

    &.scrolled,
    &.hovered {
      background: #fff;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);

      .nav_main_head,
      .nav_main_menu {
        background: #fff;
      }

      .nav-link,
      .lang-toggle,
      .action-icon {
        color: #5a5a5a;
      }

      .nav-link:hover,
      .nav-link.active,
      .lang-toggle:hover,
      .action-icon:hover {
        color: #C8A97E;
      }

      .hamburger-icon span {
        background: #5a5a5a;
      }

      .logo-img {
        filter: none;
      }
    }
  }
}

/* ============================================
   通知栏 #nav_noti_bar
   ============================================ */
.notification-bar {
  background: #f0eee2;
  padding: 10px 0;
  text-align: center;
  font-size: 13px;
  color: #6a510c;
  font-weight: 300;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.notification-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 50px;
  flex: 1;
  text-align: center;
}

.notification-arrow {
  background: none;
  border: none;
  color: #6a510c;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s, transform 0.3s;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  &:hover {
    color: #b8860b;
  }
}

.notification-prev {
  left: 20px;
}

.notification-next {
  right: 20px;
}

/* ============================================
   Wrapper 容器
   ============================================ */
.wrapper {
  // max-width: 1400px;
  margin: 0 auto;
  padding: 0 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* ============================================
   主头部 .nav_main_head
   ============================================ */
.nav_main_head {
  background: #fff;
  padding: 10px 0;
  transition: background 0.3s ease;

  .wrapper {
    align-items: center;
  }
}

/* 左侧语言切换 */
.header-left {
  flex: 0 0 200px;
}

.lang-toggle {
  font-size: 16px;
  color: #666;
  cursor: pointer;
  transition: color 0.3s;
  text-transform: uppercase;

  &:hover {
    color: #987701;
  }
}

/* 中间：logo + 导航 */
.header-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Logo */
.logo {
  cursor: pointer;
  flex-shrink: 0;
  width: 313px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-img {
  width: 313px;
  height: 50px;
  object-fit: contain;
  display: block;
}

/* 头部导航 */
.header-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
}

.nav-item {
  position: relative;

  &.has-dropdown {
    position: static;
  }
}

.nav-link {
  padding: 4px 0;
  font-size: 16px;
  font-weight: 400;
  color: #5a5a5a;
  white-space: nowrap;
  transition: color 0.3s;
  cursor: pointer;
  position: relative;

  &:hover,
  &.active {
    color: #C8A97E;
  }

  &.active::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    right: 0;
    height: 2px;
    background: #C8A97E;
  }
}

.logo-sub {
  font-size: 10px;
  color: #999;
  letter-spacing: 5px;
  margin-top: 2px;
  font-weight: 400;
}

/* ============================================
   头部操作按钮 .btn_main_bigthree
   ============================================ */
.header-actions {
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 0 0 160px;
  justify-content: flex-end;
}

.action-icon {
  cursor: pointer;
  color: #5a5a5a;
  position: relative;
  transition: color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  &:hover {
    color: #C8A97E;
  }

  svg {
    width: 24px;
    height: 24px;
  }
}

.account-dropdown-wrap {
  position: relative;
}

.account-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  min-width: 200px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  border: 1px solid #eee;
  padding: 8px 0;
  z-index: 300;
}

.account-dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
  
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: #f5f5f5;
    color: #987701;
  }
}

.account-dropdown-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: #888;
  flex-shrink: 0;

  :deep(svg) {
    width: 18px;
    height: 18px;
  }
}

.account-dropdown-item:hover .account-dropdown-icon {
  color: #987701;
}

.cart-badge,
.mail-badge {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #e0d5a7;
  color: #3d4006;
  font-size: 10px;
  font-weight: 300;
  min-width: 15px;
  height: 15px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  
}

/* 汉堡菜单图标 */
.hamburger-icon {
  display: none;
  cursor: pointer;
  flex-direction: column;
  gap: 5px;
  padding: 4px 0;

  span {
    display: block;
    width: 22px;
    height: 2px;
    background: #5a5a5a;
    transition: all 0.3s;
  }
}

/* ============================================
   搜索栏 .topsearch（65px高度条形）
   ============================================ */
.topsearch {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  z-index: 1000;
  border-bottom: 0px solid #b9aa6b;
  transition: height 0.3s ease, border-bottom 0.3s ease;

  &.active {
    height: 65px;
    border-bottom: 4px solid #b9aa6b;

    .searchbar {
      opacity: 1;
    }
  }
}

.searchbar {
  max-width: 100%;
  width: 700px;
  border: 1px solid #e8e8e8;
  border-radius: 50px;
  padding: 10px 25px;
  color: #a7a7a7;
  position: relative;
  font-weight: 200;
  cursor: pointer;
  opacity: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: opacity 0.3s ease;

  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 15px;
    color: #333;
    padding: 0;

    &::placeholder {
      color: #a7a7a7;
    }
  }
}

.search-btn {
  width: 28px;
  height: 28px;
  background: none;
  color: #a7a7a7;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.3s;

  &:hover {
    color: #987701;
  }

  svg {
    width: 18px;
    height: 18px;
  }
}

.search-close {
  width: 28px;
  height: 28px;
  background: none;
  color: #a7a7a7;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.3s;

  &:hover {
    color: #987701;
  }

  svg {
    width: 18px;
    height: 18px;
  }
}

/* ============================================
   底部菜单栏 .nav_main_menu
   白色背景 + 灰色文字 + 金色下划线
   ============================================ */
.nav_main_menu {
  display: none;
}

.menu_list_l,
.menu_list_r {
  display: flex;
  align-items: stretch;
}

.menu_list_l {
  margin-left: -20px;
}

.menu_list_r {
  margin-right: -20px;
}

.menu-center {
  display: flex;
  align-items: stretch;
}

.menu-item {
  position: relative;
  cursor: pointer;

  &.has-dropdown {
    position: static;
  }
}

.menu-link {
  padding: 0 4px;
  margin: 0px 12px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: #5a5a5a;
  white-space: nowrap;
  transition: color 0.3s;
  position: relative;
  

  &:hover,
  &.active {
    color: #333;
  }

  &.active {
    font-weight: 700;
    color: #C8A97E;
  }
}

/* "最新推廣"红色文字 */
.promotion-link {
  color: #b81836;

  &:hover,
  &.active {
    color: #b81836;
  }
}

/* 下划线效果 .effect-underline - 双线汇聚动画 */
.effect-underline {
  &::before,
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    border-radius: 2px;
    background-color: #987701;
    opacity: 0;
  }

  &::before {
    transform: translateY(-8px);
    transition: transform 0s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0s;
  }

  &::after {
    transform: translateY(4px);
    transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.2s;
  }

  &:hover::before,
  &:hover::after,
  &.active::before,
  &.active::after {
    opacity: 1;
    transform: translateY(0);
  }

  &:hover::before,
  &.active::before {
    transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0.2s;
  }

  &:hover::after,
  &.active::after {
    transition: transform 0s 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity 0s 0.2s;
  }
}

/* ============================================
   下拉菜单 mega-menu 全宽布局
   ============================================ */
.submenu-container {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #ffffff;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.25s, visibility 0.25s;
  z-index: 200;
  border-top: 1px solid #e8e8e8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);

  &.active {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
}

.submenu-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 36px 50px 40px;
  display: flex;
  align-items: flex-start;
  gap: 0;
}

.submenu-divider {
  width: 1px;
  align-self: stretch;
  background-color: #e0e0e0;
  margin: 0 40px;
  flex-shrink: 0;
}

/* ============================================
   推广下拉内容
   ============================================ */
.promotion-submenu .submenu-inner {
  align-items: stretch;
}

.promotion-box {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 220px;
  flex-shrink: 0;
  padding-top: 4px;
}

.promo-group {
  .promo-subject {
    font-size: 13px;
    color: #a39161;
    font-weight: 500;
    margin-bottom: 14px;
    
    letter-spacing: 0.5px;
  }

  .promo-title {
    font-size: 13px;
    color: #333;
    padding: 6px 0;
    cursor: pointer;
    transition: color 0.25s;
    font-weight: 300;
    line-height: 1.6;

    &:hover {
      color: #a39161;
    }

    &--accent {
      color: #a39161;

      &:hover {
        color: #8a7a52;
      }
    }
  }
}

.promotion-image-box {
  display: flex;
  gap: 32px;
  flex: 1;
  min-width: 0;
}

.promo-card {
  flex: 1;
  cursor: pointer;
  overflow: hidden;

  .promo-image {
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    background: #f5f5f5;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.4s;
    }
  }

  &:hover img {
    transform: scale(1.04);
  }

  .promo-card-title {
    font-size: 13px;
    color: #333;
    padding: 14px 0 0;
    text-align: center;
    line-height: 1.6;
    font-weight: 300;
    transition: color 0.25s;
  }

  &:hover .promo-card-title {
    color: #a39161;
  }
}

/* ============================================
   世界品牌下拉内容
   ============================================ */
.brand-submenu .submenu-inner {
  align-items: flex-start;
}

.brand-featured {
  width: 280px;
  flex-shrink: 0;
  cursor: pointer;

  .brand-featured-image {
    width: 100%;
    aspect-ratio: 4 / 3;
    overflow: hidden;
    background: #f5f5f5;
    margin-bottom: 16px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.4s;
    }
  }

  &:hover .brand-featured-image img {
    transform: scale(1.04);
  }

  .brand-featured-tag {
    font-size: 12px;
    color: #a39161;
    font-weight: 500;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
  }

  .brand-featured-title {
    font-size: 15px;
    color: #a39161;
    font-weight: 500;
    line-height: 1.5;
    margin-bottom: 10px;
    
  }

  .brand-featured-desc {
    font-size: 12px;
    color: #666;
    line-height: 1.8;
    font-weight: 300;
  }
}

.world-brand-list {
  flex: 1;
  min-width: 0;
}

.btn-showall {
  display: inline-flex;
  align-items: center;
  color: #a39161;
  font-size: 13px;
  cursor: pointer;
  margin-bottom: 24px;
  transition: color 0.25s;
  
  font-weight: 400;
  background: none;
  border: none;
  padding: 0;

  &::after {
    content: '>';
    margin-left: 4px;
    font-size: 13px;
    transition: transform 0.25s;
  }

  &:hover {
    color: #8a7a52;

    &::after {
      transform: translateX(3px);
    }
  }
}

.brand-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px 28px;
}

.brand-box {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 6px 0;
  transition: opacity 0.25s;

  &:hover {
    .name-tc {
      color: #a39161;
    }
  }
}

.brand-image {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.brand-name {
  min-width: 0;

  .name-tc {
    font-size: 13px;
    color: #333;
    font-weight: 400;
    margin-bottom: 3px;
    transition: color 0.25s;
    
    line-height: 1.3;
  }

  .name-en {
    font-size: 11px;
    color: #999;
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    line-height: 1.3;
  }
}

/* ============================================
   古巴雪茄下拉
   ============================================ */
.cuba-submenu .submenu-inner {
  max-height: 50vh;
  overflow-y: auto;
  padding-bottom: 24px;
}

.cuba-submenu-sidebar {
  width: 180px;
  flex-shrink: 0;
  padding-top: 4px;

  .sidebar-all {
    font-size: 13px;
    color: #a39161;
    cursor: pointer;
    margin-bottom: 20px;
    transition: color 0.25s;

    &:hover {
      color: #8a7a52;
    }
  }

  .sidebar-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .sidebar-item {
    font-size: 13px;
    color: #666;
    cursor: pointer;
    transition: color 0.25s;

    &:hover {
      color: #a39161;
    }
  }
}

.cuba-submenu-main {
  flex: 1;
  min-width: 0;

  .brand-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px 24px;
    margin-bottom: 28px;
  }
}

@media (max-width: 1024px) {
  .cuba-submenu-sidebar {
    display: none;
  }

  .cuba-submenu-main .brand-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* ============================================
   通知抽屉
   ============================================ */
.notification-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 499;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;

  &.active {
    opacity: 1;
    visibility: visible;
  }
}

.notification-drawer {
  position: fixed;
  top: 0;
  right: -420px;
  width: 400px;
  max-width: 90vw;
  height: 100%;
  background: #fff;
  z-index: 500;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.12);
  transition: right 0.3s ease;

  &.active {
    right: 0;
  }
}

.notification-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 44px;
  height: 44px;
  background: #333;
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: background 0.25s;

  &:hover {
    background: #555;
  }
}

.notification-drawer-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 28px 32px 32px;
  overflow: hidden;
}

.notification-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 36px;
  margin-bottom: 32px;
  flex-shrink: 0;
}

.notification-drawer-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  
}

.notification-filter {
  position: relative;
  flex-shrink: 0;
}

.notification-filter-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 108px;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  color: #333;
  font-size: 13px;
  cursor: pointer;
  
  transition: border-color 0.25s, color 0.25s;

  svg {
    transition: transform 0.25s;
  }

  &.open svg {
    transform: rotate(180deg);
  }

  &:hover {
    border-color: #bbb;
    color: #987701;
  }
}

.notification-filter-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 140px;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  z-index: 10;
}

.notification-filter-item {
  padding: 10px 16px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
  }

  &.active {
    background: #987701;
    color: #fff;

    &:hover {
      background: #886b00;
    }
  }
}

.notification-drawer-body {
  flex: 1;
  overflow-y: auto;
}

.notification-empty,
.notification-loading {
  color: #bbb;
  font-size: 14px;
  text-align: center;
  margin-top: 48px;
  
  font-weight: 300;
}

.notification-item {
  padding: 16px 10px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #fafafa;
  }

  &.unread .notification-item-title {
    font-weight: 600;
  }
}

.notification-item-title {
  font-size: 14px;
  color: #333;
  margin: 0 0 6px;
  
}

.notification-item-content {
  font-size: 13px;
  color: #666;
  margin: 0 0 8px;
  line-height: 1.6;
  font-weight: 300;
}

.notification-item-time {
  font-size: 12px;
  color: #aaa;
}

/* ============================================
   移动端菜单
   ============================================ */
.mobile-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 299;
  -webkit-tap-highlight-color: transparent;

  &.active {
    display: block;
  }
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: -300px;
  width: 300px;
  height: 100%;
  height: 100vh;
  background: #ffffff;
  z-index: 300;
  transition: right 0.3s;
  -webkit-transition: right 0.3s;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
  -webkit-transform: translateZ(0);
  transform: translateZ(0);

  &.active {
    right: 0;
  }
}

.mobile-menu-header {
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid #eeeeee;

  .close-btn {
    cursor: pointer;
    color: #5a5a5a;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s;

    &:hover {
      color: #987701;
    }

    svg {
      width: 24px;
      height: 24px;
    }
  }
}

.mobile-menu-body {
  padding: 0 16px 24px;
  -webkit-overflow-scrolling: touch;
}

.mobile-menu-link {
  padding: 14px 0;
  color: #5a5a5a;
  font-size: 15px;
  border-bottom: 1px solid #eeeeee;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: color 0.3s;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.05);
  touch-action: manipulation;

  &:hover {
    color: #987701;
  }

  &.has-children {
    .chevron-icon {
      transition: transform 0.3s;

      &.rotated {
        transform: rotate(90deg);
      }
    }
  }
}

.mobile-submenu {
  display: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  -webkit-transition: opacity 0.3s, visibility 0.3s;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  will-change: opacity, visibility;
  background-color: #f9f9f9;
  margin: 0 -16px;
  padding: 0;

  &.active {
    display: block;
    opacity: 1;
    visibility: visible;
  }
}

.mobile-submenu-all {
  color: #a39161;
  font-weight: 500;

  &:hover {
    color: #8a7a52;
  }
}

.mobile-cuba-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mobile-brand-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
}

.mobile-submenu-link {
  padding: 10px 32px;
  color: #888;
  font-size: 13px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  transition: color 0.3s;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.05);
  touch-action: manipulation;
  display: block;

  &:hover {
    color: #987701;
  }
}

.mobile-lang-toggle {
  padding: 20px 0 8px;
  border-top: 1px solid #eeeeee;
  margin-top: 8px;
}

.mobile-lang-btn {
  display: inline-block;
  padding: 10px 24px;
  background: #4a4a4a;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  transition: background 0.3s;

  &:hover {
    background: #3a3a3a;
  }
}

/* ============================================
   响应式
   ============================================ */
@media (max-width: 1280px) {
  .logo {
    width: 250px;
    height: 40px;
  }

  .logo-img {
    width: 250px;
    height: 40px;
  }

  .header-nav {
    gap: 24px;
  }
}

@media (max-width: 1024px) {
  .header-center {
    gap: 6px;
  }

  .logo {
    width: 220px;
    height: 35px;
  }

  .logo-img {
    width: 220px;
    height: 35px;
  }

  .header-nav {
    gap: 18px;
  }

  .nav-link {
    font-size: 14px;
  }
}

@media (max-width: 820px) {
  .header-left {
    display: none;
  }

  .header-center {
    align-items: flex-start;
  }

  .header-nav {
    display: none;
  }

  .nav_main_menu {
    display: none;
  }

  .hamburger-icon {
    display: flex;
  }

  .notification-bar {
    font-size: 12px;
    padding: 8px 0;
  }

  .notification-content {
    padding: 0 35px;
  }

  .notification-prev {
    left: 8px;
  }

  .notification-next {
    right: 8px;
  }

  .wrapper {
    padding: 0 20px;
  }

  .logo {
    width: auto;
    height: 32px;
  }

  .logo-img {
    width: auto;
    height: 32px;
  }

  .header-actions {
    flex: 0 0 auto;
    gap: 16px;
  }

  .action-icon {
    svg {
      width: 20px;
      height: 20px;
    }
  }

  .searchbar {
    width: 90%;
    padding: 8px 16px;
  }

  /* iOS Safari 兼容性修复 */
  .mobile-menu-item {
    -webkit-tap-highlight-color: transparent;
  }

  .mobile-menu-link,
  .mobile-submenu-link {
    -webkit-user-select: none;
    user-select: none;
    display:flex;
  }

  .chevron-icon {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    will-change: transform;
  }
}

@media (max-width: 500px) {
  .nav_main_head {
    padding: 8px 0;
  }

  .logo {
    height: 28px;
  }

  .logo-img {
    height: 28px;
  }

  .logo-sub {
    font-size: 8px;
    letter-spacing: 3px;
  }

  .header-actions {
    gap: 14px;
  }
}
</style>
